import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Ionic from '@ionic/vue';
import store from './store/store';
import 'es6-promise/auto';
import '@ionic/core/css/ionic.bundle.css';
// import './registerServiceWorker';

import { firebase } from './firebase/firebase';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

Vue.use(Ionic);
Vue.config.productionTip = false;

let app = '';
firebase.auth()
    .onAuthStateChanged(() => {
        if (!app) {
            /* eslint-disable no-new */
            app = new Vue({
                store,
                router,
                render: h => h(App),
            }).$mount('#app');
        }
    });


// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
